import { ReactNode, useEffect } from "react";
import AOS from "aos";
import { useRouter } from "next/router";

// These are all imported statically on purpose. Every one of them is part of the
// layout chrome rendered on every page with SSR enabled, so a dynamic() boundary
// buys no code splitting, delays above-the-fold content, and makes the client's
// first hydration pass render a loading/null state that does not match the
// server HTML. SmoothScroll is the worst case since it wraps the whole tree.
import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "../Components/CookieConsent";
import PreferredSourceBadge from "../Components/common/PreferredSourceBadge";
import DreamforceCampaign from "../Components/DreamforceCampaign";
import SmoothScroll from "../Components/common/SmoothScroll";
import "aos/dist/aos.css";

interface LayoutProps {
  children: ReactNode;
  slug?: string;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const router = useRouter();
  const isLandingPage = router.pathname.startsWith("/lp/");

  useEffect(() => {
    AOS.init({
      duration: 1200, // animation duration (in ms)
      once: false, // animate only once
      mirror: false,
    });
    AOS.refresh();
  }, []);

  return (
    <SmoothScroll>
      <div
        id="root"
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <DreamforceCampaign />
        {!isLandingPage && <Header />}
        <main style={{ flex: 1 }}>{children}</main>
        {!isLandingPage && <Footer />}
        <CookieConsent />
        <PreferredSourceBadge />
      </div>
    </SmoothScroll>
  );
};
export default Layout;
